import { FsFile, FsFileMetadata } from "./types";

const MAX_LENGTH = 40;

export const truncateName = (name: string, length = MAX_LENGTH) =>
  name.slice(0, length) + (name.length > length ? "..." : "");

export enum FileSizes {
  KB = 1_000,
  MB = 1_000_000,
  GB = 1_000_000_000,
  TB = 1_000_000_000_000,
  PB = 1_000_000_000_000_000,
}

export const bytesToReadable = (bytes: number, decimalPlaces: number = 0) => {
  const [unit, size] = getGreatestSmallerFileSize(bytes);

  return `${parseFloat((bytes / size).toFixed(decimalPlaces))} ${unit}`;
};

const getGreatestSmallerFileSize = (bytes: number) => {
  const minFileSize = ["KB", FileSizes.KB];
  const greatestSmaller = Object.entries(FileSizes).reduce(
    (greatestSmaller, [type, size]) => (size <= bytes ? [type, size] : greatestSmaller),
    minFileSize
  ) as [keyof typeof FileSizes, FileSizes];

  return greatestSmaller;
};

export const getFileMetadata = (file: FsFile, originalFile: File): FsFileMetadata => {
  const { name, size, type } = file._file;
  return {
    ...file,
    name,
    size,
    type,
    filename: name,
    mimetype: originalFile.type,
  };
};
